import { createContext, useContext } from 'react';
import { IReadableAuthState, IWratableAuthState } from '../../core';

const authStatusContext = createContext<null | (IReadableAuthState & IWratableAuthState)>(null);

export const useAuthStatusWriter = () => {
  const store = useContext(authStatusContext);

  if (!store) throw new Error('useAuthStatusWriter must be within AuthStatusProvider');

  return store as IWratableAuthState;
};

export const useAuthStatus = () => {
  const store = useContext(authStatusContext);

  if (!store) throw new Error('useAuthStatus must be within AuthStatusProvider');

  return store as IReadableAuthState;
};

export const AuthStatusProvider = authStatusContext.Provider;
